import React from 'react';

export const Header = (props) => {

  return (
    <header id='header'>
      <div className='intro'>
        <div className='overlay'>
          <div className='container'>
            <div className='row'>
              {/* <img width={100} height="auto" src="/public/img/portadaCenterNew.jpg" alt="Seguridad Ciudadana"/> */}
              <div className='col-md-8 col-md-offset-2 intro-text'>
                {/* <h1 style={{ paddingTop: '100px', paddingBottom: '100px' }}>
                  {props.data ? props.data.title : 'Loading'}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : 'Loading'}</p> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
